import { executeRequest, Request } from '@jfs/network'
import { appAuthGenerateRequestBody, appAuthVerifyRequestBody } from '../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  if (data.status === 'SUCCESS') {
    return data
  } else {
    throw data.error ?? 'An unexpected error has occured!'
  }
}

const appAuthGenerate = (codeVerifier: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.APPAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: appAuthGenerateRequestBody(codeVerifier),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

const appAuthVerify = (authCode: string, codeVerifier: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.APPAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: appAuthVerifyRequestBody(authCode, codeVerifier),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { appAuthGenerate, appAuthVerify }
